import React from 'react';
import './ImageStyleSheet.css';

function ImageInkTwo() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/7ink2.jpg" className='img-view'/>
        </div>
    )
}

export default ImageInkTwo
